import type { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-swiss-white text-swiss-black font-swiss-sans text-[14px] antialiased flex flex-col">
      <Header />
      <main className="flex-1 max-w-[1440px] mx-auto w-full px-12 py-12">
        {children}
      </main>
      <Footer />
    </div>
  )
}
